module.exports = __webpack_public_path__ + "img/input.15912266.svg";